/* Touch-point and behaviour events for GA4, every page (Aditya, 2026-11-03/04, fixes 2026-11-04 07:50:
   "every event on the Winter is Coming page and all PDPs", home banners and
   category cards, scroll depth, sheet behaviour, size choice, drop-offs).
   One file, loaded once (guarded), one delegated click listener, a few
   observers. Every event carries `page` (home | collection | product |
   other), the collection handle or product handle where there is one, the
   A/B side on the ads page, and small `label` / `state` / `frame` /
   `position` params. Names are fixed strings so GA4 reports them without
   custom dimensions; the params are registered as custom dimensions
   (label, handle, collection, position, nth, href, variant, page, state,
   frame, metric) and `ms` as a custom metric. Nothing here touches the
   cart or checkout. */
(function () {
  'use strict';
  if (window.__tzTrack) return;
  window.__tzTrack = true;
  var doc = document, html = doc.documentElement, body = doc.body;
  var send = function (name, params) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, params || {}); } catch (e) { /* analytics never breaks the page */ }
  };
  var handleOf = function (href) { var m = /\/products\/([a-z0-9-]+)/i.exec(href || ''); return m ? m[1] : ''; };
  var text = function (el) { return (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60); };
  var col = doc.querySelector('.v-col[data-collection][data-handle]');
  var pdp = doc.querySelector('.v-pdp[data-product-handle]');
  var page = pdp ? 'product' : col ? 'collection' : (location.pathname === '/' ? 'home' : 'other');
  var collection = col ? col.getAttribute('data-handle') : '';
  var handle = pdp ? pdp.getAttribute('data-product-handle') : '';
  var sheetState = function () { return body.getAttribute('data-pdp-sheet-state') || 'none'; };
  var base = function (extra) {
    var p = { page: page };
    if (collection) p.collection = collection;
    if (handle) p.handle = handle;
    var ab = html.getAttribute('data-ab-fw');
    if (!ab) { try { ab = localStorage.getItem('tz:ab_fw') || ''; } catch (e) { ab = ''; } }
    if (ab) p.variant = ab;
    if (pdp) p.state = sheetState();
    for (var k in extra) if (extra[k] !== undefined && extra[k] !== '' && extra[k] !== null) p[k] = extra[k];
    return p;
  };
  var LAST = 'tz:lastPdp';
  var lastAtc = 0;
  doc.addEventListener('submit', function (ev) { var f = ev.target; if (f && /\/cart\/add/.test((f.getAttribute && f.getAttribute('action')) || '')) lastAtc = Date.now(); }, true);

  /* ---------- product page: remember itself for the collection's back read ---------- */
  if (pdp) {
    try {
      var h1 = doc.querySelector('.v-pdp h1, .v-pdp__title');
      sessionStorage.setItem(LAST, JSON.stringify({ handle: handle, title: h1 ? h1.textContent.trim() : '', at: Date.now() }));
    } catch (e) { /* storage blocked */ }
  }
  /* ---------- collection page: came back from a product ---------- */
  if (col) {
    var backRead = function (persisted) {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
      var isBack = persisted || (nav && nav.type === 'back_forward');
      var ref = handleOf(doc.referrer);
      if (!isBack && !ref) return;
      var last = null;
      try { last = JSON.parse(sessionStorage.getItem(LAST) || 'null'); } catch (e) { /* ignore */ }
      var from = (last && last.handle) || ref;
      if (!from || (last && Date.now() - last.at > 30 * 60 * 1000)) return;
      send('back_to_collection', base({ handle: from, label: last && last.title, items: [{ item_id: from, item_name: (last && last.title) || from }] }));
      try { sessionStorage.removeItem(LAST); } catch (e) { /* ignore */ }
    };
    backRead(false);
    window.addEventListener('pageshow', function (e) { if (e.persisted) backRead(true); });
  }

  /* ---------- scroll depth, every page: 25 / 50 / 75 / 100 once per load ---------- */
  var marks = [25, 50, 75, 100], sent = {}, ticking = false;
  var frames = pdp ? Array.prototype.slice.call(doc.querySelectorAll('.v-pdp__media .v-pdp__media-item:not(.v-pdp__media-item--placeholder)')) : [];
  var maxFrame = 0, framesSent = {}, reviews = doc.getElementById('community-reviews'), reviewsSeen = false, reviewsBack = false;
  var recsEl = doc.querySelector('[data-rec-list]'), recsSeen = false, closedSheetOnce = false, retractThenScroll = false;
  var onScroll = function () {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight;
    var total = Math.max(html.scrollHeight, body.scrollHeight) - vh;
    if (total > 0) {
      var pct = Math.round((y / total) * 100);
      for (var i = 0; i < marks.length; i++) if (pct >= marks[i] && !sent[marks[i]]) { sent[marks[i]] = true; send('scroll_' + marks[i], base({})); }
    }
    if (!pdp) return;
    /* which gallery frame is on screen: the image scroll depth */
    for (var f = 0; f < frames.length; f++) {
      var r = frames[f].getBoundingClientRect();
      if (r.top < vh * 0.6 && r.bottom > vh * 0.4) {
        var n = f + 1;
        if (n > maxFrame) maxFrame = n;
        if (!framesSent[n]) { framesSent[n] = true; send('pdp_frame', base({ frame: n })); if (closedSheetOnce && !retractThenScroll) { retractThenScroll = true; send('sheet_retract_then_scroll', base({ frame: n })); } }
        break;
      }
    }
    if (reviews) {
      var rr = reviews.getBoundingClientRect();
      if (!reviewsSeen && rr.top < vh * 0.8) { reviewsSeen = true; send('reviews_reached', base({ frame: maxFrame })); }
      else if (reviewsSeen && !reviewsBack && rr.top > vh) { reviewsBack = true; send('reviews_back_up', base({})); }
    }
    if (recsEl && !recsSeen) { var rc = recsEl.getBoundingClientRect(); if (rc.top < vh * 0.8) { recsSeen = true; send('recs_reached', base({ frame: maxFrame })); } }
  };
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* ---------- PDP sheet: states, open / close, images seen before opening ---------- */
  if (pdp && window.MutationObserver) {
    var prev = sheetState(), opens = 0;
    var initialSize = (doc.querySelector('.v-pdp__swatch.is-selected') || {}).getAttribute ? doc.querySelector('.v-pdp__swatch.is-selected').getAttribute('data-option-value') : '';
    new MutationObserver(function () {
      var now = sheetState();
      if (now === prev) return;
      var from = body.getAttribute('data-pdp-sized-from') || '';
      send('sheet_state', base({ state: now, label: prev + '>' + now + (from ? ':' + from : ''), frame: maxFrame }));
      if (prev === 'compact' && now !== 'compact') { opens++; window.__tzOpens = opens; send('sheet_open', base({ state: now, label: from || now, frame: maxFrame, nth: opens })); }
      if (now === 'compact' && prev !== 'compact') { closedSheetOnce = true; send('sheet_close', base({ state: prev, frame: maxFrame })); }
      if (now === 'sized') send('atc_open', base({ state: 'sized', label: from || 'default', frame: maxFrame }));
      prev = now;
    }).observe(body, { attributes: true, attributeFilter: ['data-pdp-sheet-state'] });
    /* the real add: the cart action flips to is-added */
    var cartAction = doc.querySelector('.v-pdp__cart-action');
    if (cartAction) new MutationObserver(function () {
      if (!cartAction.classList.contains('is-added') || cartAction.__tzAdded || Date.now() - lastAtc > 15000) return;
      cartAction.__tzAdded = true;
      var size = (doc.querySelector('.v-pdp__swatch.is-selected') || { getAttribute: function () { return ''; } }).getAttribute('data-option-value') || '';
      send('atc_added', base({ label: size, nth: size && initialSize && size !== initialSize ? 2 : 1, frame: maxFrame }));
      send(size && initialSize && size !== initialSize ? 'atc_added_size_changed' : 'atc_added_default_size', base({ label: size }));
      setTimeout(function () { cartAction.__tzAdded = false; }, 1500);
    }).observe(cartAction, { attributes: true, attributeFilter: ['class'] });
    /* the 3D stage opens the lightbox on pointerup, before any click is
       dispatched, so the tap is counted when the lightbox opens with the model */
    var lightbox = doc.querySelector('[data-pdp-lightbox]');
    if (lightbox) new MutationObserver(function () {
      if (lightbox.open && lightbox.querySelector('.v-lightbox__model')) send('click_3d', base({ frame: maxFrame }));
    }).observe(lightbox, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------- every tap, by element family (first match wins) ---------- */
  var cardPos = function (card) { var p = card.parentElement; if (!p) return undefined; var cs = p.querySelectorAll(':scope > .v-card'); if (cs.length < 2 && p.parentElement) cs = p.parentElement.querySelectorAll(':scope > * > .v-card'); for (var i = 0; i < cs.length; i++) if (cs[i] === card) return i + 1; return undefined; };
  var sectionOf = function (el) { var s = el.closest('.shopify-section'); return s ? s.id.replace(/^shopify-section-(template--\d+__|sections--\d+__)?/, '') : ''; };
  var recList = function (el) { var r = el.closest('[data-rec-list]'); return r ? r.getAttribute('data-rec-list') : ''; };
  var nth = function (h) { try { var m = JSON.parse(localStorage.getItem('tz:cardClicks') || '{}'); m[h] = (m[h] || 0) + 1; localStorage.setItem('tz:cardClicks', JSON.stringify(m)); return m[h]; } catch (e) { return 1; } };
  var FAM = [
    /* chrome */
    ['[data-tz-back]', function () { return ['click_back', {}]; }],
    ['.tz-toppill__home, .tz-brand, .v-header__brand, .tz-homemark', function () { return ['click_logo', {}]; }],
    ['[data-tz-share]', function () { return ['click_share', {}]; }],
    ['[data-open-search]', function (el) { return ['click_search', { label: el.classList.contains('tz-fab') ? 'fab' : '' }]; }],
    ['[data-pdp-sheet-visit], [data-pdp-cart-link]', function () { return ['click_visit_bag', {}]; }],
    ['[data-open-cart], [data-tz-bag]', function (el) { return ['click_bag', { label: el.classList.contains('tz-fab') ? 'fab' : '' }]; }],
    ['[data-toggle-menu], [data-tz-pane]', function (el) { return ['click_menu', { label: text(el) }]; }],
    ['.tz-tab', function (el) { return ['click_tab', { label: text(el) }]; }],
    ['.tz-fab', function (el) { return ['click_fab', { label: text(el) }]; }],
    /* home */
    ['.v-hero-banner__slide', function (el) { return ['click_hero', { label: text(el), href: el.getAttribute('href') || '' }]; }],
    ['[data-bc-dot], [data-bc-nav]', function (el) { return ['click_hero_nav', { label: text(el) }]; }],
    ['.v-frail__banner', function (el) { return ['click_rail_banner', { label: text(el), href: el.getAttribute('href') || '' }]; }],
    ['.v-crail__card', function (el) { return ['click_category_card', { label: (el.getAttribute('href') || '').replace('/collections/', ''), position: sectionOf(el) }]; }],
    ['[data-crail-prev], [data-crail-next], [data-looks-prev], [data-looks-next]', function (el) { return ['click_rail_arrow', { label: text(el), position: sectionOf(el) }]; }],
    ['.tz-gender__btn', function (el) { return ['click_gender', { label: text(el) }]; }],
    ['.tz-album', function (el) { return ['click_album_tile', { label: (el.getAttribute('href') || '').replace('/collections/', '') }]; }],
    /* collection */
    ['.v-col__lede, .v-col__lede-media, .v-col__banner', function () { return ['click_album', {}]; }],
    ['a.v-tcards__card', function (el) { return ['click_category_card', { label: el.getAttribute('data-tcard-value') || text(el) }]; }],
    ['.v-col__pill--all', function () { return ['click_filter_open', { label: 'all' }]; }],
    ['.v-col__pill[data-filter-group]', function (el) { return ['click_filter_pill', { label: el.getAttribute('data-filter-group') || text(el) }]; }],
    ['.v-refine-dock__btn', function (el) { return ['click_dock', { label: el.getAttribute('data-filter-mode') || text(el) }]; }],
    ['.v-col-drawer__tab', function (el) { return ['click_drawer_tab', { label: el.getAttribute('data-tab') || text(el) }]; }],
    ['.v-f2__navitem', function (el) { return ['click_filter_group', { label: el.getAttribute('data-f2-tab') || text(el) }]; }],
    ['.v-fg__checkbox', function (el) { return [el.checked ? 'filter_check' : 'filter_uncheck', { label: (el.name || '') + '=' + (el.value || '') }]; }],
    ['.v-f2__allbox', function (el) { return [el.checked ? 'filter_check' : 'filter_uncheck', { label: 'all:' + (el.getAttribute('data-f2-all') || el.name || '') }]; }],
    ['.v-col-drawer__apply', function () { return ['filter_apply', {}]; }],
    ['.v-col-drawer__clear', function () { return ['filter_clear', {}]; }],
    ['.v-col-drawer__close', function () { return ['filter_close', {}]; }],
    ['[data-load-more], .v-load-more__btn', function () { return ['click_load_more', {}]; }],
    /* cards anywhere (grid, rails, recs) */
    ['[data-card-qv]', function (el) { var c = el.closest('a.v-card'); return ['click_card_quickview', { handle: c ? handleOf(c.getAttribute('href')) : '', position: sectionOf(el) || recList(el) }]; }],
    ['[data-card-add]', function (el) { var c = el.closest('a.v-card, [data-look-card]'); var a = c && c.querySelector ? (c.getAttribute('href') || (c.querySelector('a[href]') || {}).getAttribute && c.querySelector('a[href]').getAttribute('href')) : ''; return ['click_card_quickadd', { label: text(el), handle: handleOf(a), position: sectionOf(el) || recList(el) }]; }],
    ['[data-notify-open]', function (el) { return ['click_notify', { handle: el.getAttribute('data-notify-handle') || '' }]; }],
    ['a.v-card', function (el) {
      var h = handleOf(el.getAttribute('href')), n = nth(h), list = recList(el);
      var evt = list ? 'click_rec' : 'click_card';
      return [evt, { handle: h, label: list || sectionOf(el) || text(el), position: cardPos(el), nth: n }, n > 1 && !list ? 'click_card_repeat' : null];
    }],
    ['[data-recs-more-btn]', function (el) { return ['click_rec_more', { label: recList(el) }]; }],
    /* shop the look */
    ['.v-looks__photo-link', function (el) { return ['click_look_photo', { handle: handleOf(el.getAttribute('href')), label: text(el) }]; }],
    ['[data-look-dot]', function (el) { return ['click_look_dot', { label: text(el) }]; }],
    ['.v-looks__card-media, .v-looks__card-title, .v-looks__card-link', function (el) { return ['click_look_card', { handle: handleOf(el.getAttribute('href')), label: text(el) }]; }],
    ['[data-looks-side-add]', function () { return ['click_look_add_all', {}]; }],
    ['.v-lookdetail__view, .v-lookdetail__title', function (el) { return ['click_pair_tile', { handle: handleOf(el.getAttribute('href')) }]; }],
    /* PDP */
    ['[data-pdp-zoom]:not([data-zoom-type="model"])', function (el) { var f = frames.indexOf(el.closest('.v-pdp__media-item')); return ['click_photo_zoom', { frame: f >= 0 ? f + 1 : maxFrame }]; }],
    ['[data-pdp-sheet-plus]', function (el) { return ['click_atc_main', { label: el.getAttribute('data-mode') || 'compact', frame: maxFrame }]; }],
    ['[data-pdp-open-sizes]', function (el) { return ['click_atc_main', { label: 'bar:' + text(el), frame: maxFrame }]; }],
    ['[data-pdp-sheet-toggle]', function (el) { return ['click_sheet_toggle', { label: el.tagName === 'BUTTON' ? 'handle' : 'title', frame: maxFrame }]; }],
    ['[data-pdp-swatch]', function (el) { return ['size_pick', { label: el.getAttribute('data-option-value') || text(el) }]; }],
    ['[data-pdp-atc]', function () { var s = doc.querySelector('.v-pdp__swatch.is-selected'); return ['click_atc_add', { label: s ? s.getAttribute('data-option-value') : '', frame: maxFrame }]; }],
    ['[data-open-size-chart]', function (el) { return ['size_guide', { label: el.className.indexOf('sheet') >= 0 ? 'sheet' : 'accordion' }]; }],
    ['[data-pdp-emi-open]', function () { return ['emi_open', {}]; }],
    ['[data-trust-open]', function (el) { return ['trust_open', { label: text(el) }]; }],
    ['[data-trust-tab]', function (el) { return ['trust_tab', { label: text(el) }]; }],
    ['[data-pdp-rating-link]', function (el) { return ['rating_pill', { label: /floating/.test(el.className) ? 'floating' : /sheet/.test(el.className) ? 'sheet' : 'desktop' }]; }],
    ['[data-crev-jump]', function () { return ['rating_pill', { label: 'reviews-button' }]; }],
    ['.pdp-angels__review-summary', function () { return ['review_open', {}]; }],
    ['[data-pdp-desc-toggle]', function () { return ['click_desc_toggle', {}]; }],
    ['.v-pdp__acc-summary', function (el) { return ['click_accordion', { label: text(el) }]; }],
    ['[data-pdp-fab]', function (el) { return ['click_fab', { label: text(el) }]; }],
    ['.v-pdp__vendor-link, .v-pdp__sheet-eyebrow-link', function (el) { return ['click_eyebrow', { label: text(el) }]; }],
    /* anything else */
    ['.v-footer__logo', function () { return ['click_footer', { label: 'logo' }]; }],
    ['footer a, .v-footer a', function (el) { return ['click_footer', { label: el.getAttribute('href') || text(el) }]; }],
    ['a[href], button, [role="button"], summary', function (el) { return ['click_other', { label: text(el) || el.className.toString().slice(0, 40), href: (el.getAttribute('href') || '').slice(0, 80) }]; }]
  ];
  /* on window, not document: the notify sheet stops every document-level
     capture listener; script-made clicks (visit bag forwarding, the sheet's
     size follow) are not taps, so only trusted events count */
  window.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest || ev.isTrusted === false) return;
    for (var i = 0; i < FAM.length; i++) {
      var el = t.closest(FAM[i][0]);
      if (!el) continue;
      var r = FAM[i][1](el);
      if (!r) return;
      send(r[0], base(r[1]));
      if (r[2]) send(r[2], base(r[1]));
      return;
    }
  }, true);
  doc.addEventListener('change', function (ev) {
    var el = ev.target;
    if (el && el.matches && el.matches('.v-col-drawer__sort-input')) send('sort_pick', base({ label: el.value || '' }));
  }, true);

  /* ---------- performance: LCP, CLS, INP, TTFB once per page ---------- */
  try {
    var nav0 = performance.getEntriesByType('navigation')[0];
    if (nav0) send('web_vitals', base({ metric: 'ttfb', ms: Math.round(nav0.responseStart) }));
    if (window.PerformanceObserver) {
      var lcp = 0, cls = 0, inp = 0;
      new PerformanceObserver(function (l) { var e = l.getEntries(); if (e.length) lcp = e[e.length - 1].startTime; }).observe({ type: 'largest-contentful-paint', buffered: true });
      new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { if (!e.hadRecentInput) cls += e.value; }); }).observe({ type: 'layout-shift', buffered: true });
      try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { if (e.duration > inp) inp = e.duration; }); }).observe({ type: 'event', buffered: true, durationThreshold: 40 }); } catch (e) { /* no INP */ }
      var flushed = false;
      var flush = function () {
        if (flushed) return; flushed = true;
        if (lcp) send('web_vitals', base({ metric: 'lcp', ms: Math.round(lcp) }));
        send('web_vitals', base({ metric: 'cls', ms: Math.round(cls * 1000) }));
        if (inp) send('web_vitals', base({ metric: 'inp', ms: Math.round(inp) }));
      };
      doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') flush(); });
      window.addEventListener('pagehide', flush);
    }
  } catch (e) { /* ignore */ }

  /* ---------- PDP summary once per visit: did they scroll the photos, open the
     sheet, both, neither; how many photos; how many opens ---------- */
  if (pdp) {
    var summed = false;
    var summary = function () {
      if (summed) return; summed = true;
      var scrolled = maxFrame >= 2, opened = closedSheetOnce || sheetState() !== 'compact' || body.hasAttribute('data-pdp-sized-from');
      var opensN = 0; try { opensN = window.__tzOpens || 0; } catch (e) { /* ignore */ }
      send('pdp_summary', base({ label: scrolled && opened ? 'both' : scrolled ? 'scroll_only' : opened ? 'sheet_only' : 'neither', frame: maxFrame, nth: opensN, state: 'end' }));
    };
    doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') summary(); });
    window.addEventListener('pagehide', summary);
  }
})();
